import src from "IMAGE";
export default { src, width: 236, height: 60, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR42m3DMQ4AEAwF0K4q8ZnEkURMEnELg4RFevZeoMMjdgGeES0JudCo+812vmX1Kwodlg4065Kh4AAAAABJRU5ErkJggg=="};
